export const communicationReducer = (state = {
    loading: false,
    messages: [],
    messageError: null,
    notifications: [],
    notificationsLoading: false,
    unreadCount: 0,
    noticeboard: [],
    noticeboardLoading: false,
    sentMessages: [],
    sentLoading: false,
    thread: [],
    threadLoading: false,
    messageSending: false,
    messageSuccess: null,
    messageError2: null
}, action) => {
    switch (action.type) {
        case 'MESSAGES_LOADING':
            return { ...state, loading: true }
        case 'MESSAGES_SUCCESS':
            return { ...state, loading: false, messages: action.payload }
        case 'MESSAGES_ERROR':
            return { ...state, loading: false, messageError: action.payload }

        case 'NOTIFICATIONS_LOADING':
            return { ...state, notificationsLoading: true }
        case 'NOTIFICATIONS_SUCCESS':
            return {
                ...state,
                notificationsLoading: false,
                notifications: action.payload,
                unreadCount: action.payload.filter(n => !n.read).length
            }
        case 'NOTIFICATIONS_ERROR':
            return { ...state, notificationsLoading: false, messageError: action.payload }

        case 'NOTICEBOARD_LOADING':
            return { ...state, noticeboardLoading: true }
        case 'NOTICEBOARD_SUCCESS':
            return { ...state, noticeboardLoading: false, noticeboard: action.payload }
        case 'NOTICEBOARD_ERROR':
            return { ...state, noticeboardLoading: false, messageError: action.payload }

        case 'SENT_LOADING':
            return { ...state, sentLoading: true }
        case 'SENT_SUCCESS':
            return { ...state, sentLoading: false, sentMessages: action.payload }
        case 'SENT_ERROR':
            return { ...state, sentLoading: false, messageError: action.payload }

        case 'THREAD_LOADING':
            return { ...state, threadLoading: true }
        case 'THREAD_SUCCESS':
            return { ...state, threadLoading: false, thread: action.payload }
        case 'THREAD_ERROR':
            return { ...state, threadLoading: false, messageError: action.payload }
        case 'THREAD_RESET':
            return { ...state, thread: [], threadLoading: false }

        case 'MARK_READ':
            return {
                ...state,
                notifications: state.notifications.map(n =>
                    n._id === action.payload ? { ...n, read: true } : n
                ),
                unreadCount: state.notifications.filter(n => !n.read && n._id !== action.payload).length
            }

        case 'MARK_ALL_READ':
            return {
                ...state,
                notifications: state.notifications.map(n => ({ ...n, read: true })),
                unreadCount: 0
            }

        case 'MESSAGE_SENDING':
            return { ...state, messageSending: true, messageSuccess: null, messageError2: null }
        case 'MESSAGE_SEND_SUCCESS':
            return { ...state, messageSending: false, messageSuccess: action.payload }
        case 'MESSAGE_SEND_ERROR':
            return { ...state, messageSending: false, messageError2: action.payload }
        case 'MESSAGE_SEND_RESET':
            return { ...state, messageSending: false, messageSuccess: null, messageError2: null }

        case 'MESSAGE_DELETED':
            return {
                ...state,
                noticeboard: state.noticeboard.filter(n => n._id !== action.payload),
                notifications: state.notifications.filter(n => n._id !== action.payload),
                sentMessages: state.sentMessages.filter(n => n._id !== action.payload)
            }

        default:
            return state
    }
}
